import styled, { css } from 'styled-components';
import { mix } from 'polished';

import { defaultThemeProp, StyledLink } from '@pega/cosmos-react-core';
import { listStyles } from '@pega/cosmos-react-core/lib/components/HTML/HTML';

import type { RichTextEditorProps } from './RichTextEditor.types';

export const StyledEditorContainer = styled.div<{
  containerHeight?: RichTextEditorProps['height'];
}>(({ containerHeight, theme }) => {
  return css`
    padding: ${theme.base.spacing};

    ${typeof containerHeight === 'string' &&
    css`
      height: ${containerHeight};
    `}

    ${typeof containerHeight === 'object' &&
    css`
      ${containerHeight.min &&
      css`
        min-height: ${containerHeight.min};
      `}

      ${containerHeight.max &&
      css`
        max-height: ${containerHeight.max};
      `}
    `}

      &:hover {
      cursor: text;
    }

    ${listStyles}
  `;
});

StyledEditorContainer.defaultProps = defaultThemeProp;

const StyledRichTextEditor = styled.div<{ focused?: boolean; hasSuggestion?: boolean }>(
  ({ theme, focused, hasSuggestion }) => {
    return css`
      background-color: ${hasSuggestion && theme.components['form-field'].pending
        ? mix(
            0.1,
            theme.components['form-field'].pending['status-color'],
            theme.components['form-control']['background-color']
          )
        : theme.components['form-control']['background-color']};
      width: 100%;
      position: relative;
      box-shadow: none;
      overflow: hidden;

      /* Override default styling of slate placeholder. */
      span[data-slate-placeholder='true'] {
        position: absolute;
        inset-block-start: 0;
        opacity: ${theme.base.transparency['transparent-3']};
      }

      ${hasSuggestion &&
      css`
        /* Adding explicit styles for suggestion state */
        border-color: ${theme.components['form-field'].pending['status-color']};
      `}

      ${focused &&
      css`
        &:not([disabled]) {
          border-color: ${theme.components['form-control'][':focus']['border-color']};
          box-shadow: ${theme.components['form-control'][':focus']['box-shadow']};
        }

        &:hover:not([readonly]):not([disabled]):not(:focus, :focus-within) {
          border-color: transparent;
        }
      `}
    `;
  }
);

StyledRichTextEditor.defaultProps = defaultThemeProp;

export const StyledRichTextViewer = styled.div`
  width: 100%;
  position: relative;
  overflow-wrap: break-word;

  ${StyledLink} {
    &:enabled:focus,
    &:not([disabled]):focus {
      box-shadow: none;
      text-decoration: underline;
    }
  }
`;

export default StyledRichTextEditor;
